export default [
    {
        "error_id": "DSRC-02",
        "data": [
            {
                "cross_section": "4069",
                "type": "removed",
                "accurate": "accurate"
            },
            {
                "cross_section": "4010",
                "type": "added",
                "accurate": "not accurate"
            },
            {
                "cross_section": "3800",
                "type": "removed",
                "accurate": "accurate"
            },
            {
                "cross_section": "1692",
                "type": "added",
                "accurate": "not accurate"
            },
            {
                "cross_section": "1455",
                "type": "added",
                "accurate": "not accurate"
            }
        ]
    },
    {
        "error_id": "T-DSRC-01",
        "data": [
            {
                "cross_section": "4397",
                "base": {
                    "channel": 79.46,
                    "lob": 79.46,
                    "rob": 79.46
                },
                "compare": {
                    "channel": 101,
                    "lob": 101,
                    "rob": 101
                }
            },
            {
                "cross_section": "4296",
                "base": {
                    "channel": 129.46,
                    "lob": 144,
                    "rob": 19.94
                },
                "compare": {
                    "channel": 100,
                    "lob": 105,
                    "rob": 100
                }
            },
            {
                "cross_section": "4196",
                "base": {
                    "channel": 72,
                    "lob": 66.86,
                    "rob": 62.84
                },
                "compare": {
                    "channel": 127,
                    "lob": 127,
                    "rob": 127
                }
            },
            {
                "cross_section": "4069",
                "base": {
                    "channel": 80.25,
                    "lob": 76.59,
                    "rob": 81.63
                },
                "compare": {
                    "channel": 59,
                    "lob": 59,
                    "rob": 59
                }
            },
            {
                "cross_section": "3951",
                "base": {
                    "channel": 130.99,
                    "lob": 122.89,
                    "rob": 135.03
                },
                "compare": {
                    "channel": 127,
                    "lob": 127,
                    "rob": 127
                }
            },
            {
                "cross_section": "3824",
                "base": {
                    "channel": 96.04,
                    "lob": 81.89,
                    "rob": 104.47
                },
                "compare": {
                    "channel": 233,
                    "lob": 233,
                    "rob": 233
                }
            },
            {
                "cross_section": "3591",
                "base": {
                    "channel": 312.57,
                    "lob": 277.23,
                    "rob": 299.01
                },
                "compare": {
                    "channel": 214,
                    "lob": 214,
                    "rob": 214
                }
            },
            {
                "cross_section": "3377",
                "base": {
                    "channel": 262.35,
                    "lob": 226.75,
                    "rob": 250.66
                },
                "compare": {
                    "channel": 210,
                    "lob": 210,
                    "rob": 210
                }
            },
            {
                "cross_section": "3167",
                "base": {
                    "channel": 198.52,
                    "lob": 168.37,
                    "rob": 189.69
                },
                "compare": {
                    "channel": 220,
                    "lob": 220,
                    "rob": 220
                }
            },
            {
                "cross_section": "2947",
                "base": {
                    "channel": 106.74,
                    "lob": 104.14,
                    "rob": 88.68
                },
                "compare": {
                    "channel": 138,
                    "lob": 138,
                    "rob": 138
                }
            },
            {
                "cross_section": "2809",
                "base": {
                    "channel": 67.73,
                    "lob": 90.67,
                    "rob": 45.05
                },
                "compare": {
                    "channel": 101,
                    "lob": 101,
                    "rob": 101
                }
            },
            {
                "cross_section": "2708",
                "base": {
                    "channel": 96.53,
                    "lob": 92.83,
                    "rob": 80.19
                },
                "compare": {
                    "channel": 100,
                    "lob": 100,
                    "rob": 100
                }
            },
            {
                "cross_section": "2608",
                "base": {
                    "channel": 101.74,
                    "lob": 80.29,
                    "rob": 119.74
                },
                "compare": {
                    "channel": 127,
                    "lob": 127,
                    "rob": 127
                }
            },
            {
                "cross_section": "2481",
                "base": {
                    "channel": 368.77,
                    "lob": 291,
                    "rob": 367.26
                },
                "compare": {
                    "channel": 123,
                    "lob": 123,
                    "rob": 123
                }
            },
            {
                "cross_section": "2358",
                "base": {
                    "channel": 250.91,
                    "lob": 215.34,
                    "rob": 249.37
                },
                "compare": {
                    "channel": 200,
                    "lob": 200,
                    "rob": 200
                }
            },
            {
                "cross_section": "2158",
                "base": {
                    "channel": 266.27,
                    "lob": 251.73,
                    "rob": 247
                },
                "compare": {
                    "channel": 263,
                    "lob": 263,
                    "rob": 263
                }
            },
            {
                "cross_section": "1895",
                "base": {
                    "channel": 36.9,
                    "lob": 30.66,
                    "rob": 31.76
                },
                "compare": {
                    "channel": 73,
                    "lob": 73,
                    "rob": 73
                }
            },
            {
                "cross_section": "1822",
                "base": {
                    "channel": 54.38,
                    "lob": 74.11,
                    "rob": 29.76
                },
                "compare": {
                    "channel": 77,
                    "lob": 77,
                    "rob": 77
                }
            },
            {
                "cross_section": "1745",
                "base": {
                    "channel": 103.76,
                    "lob": 119.92,
                    "rob": 75.26
                },
                "compare": {
                    "channel": 53,
                    "lob": 53,
                    "rob": 53
                }
            },
            {
                "cross_section": "1514",
                "base": {
                    "channel": 70.43,
                    "lob": 70.43,
                    "rob": 70.43
                },
                "compare": {
                    "channel": 59,
                    "lob": 59,
                    "rob": 59
                }
            },
            {
                "cross_section": "1307",
                "base": {
                    "channel": 86.58,
                    "lob": 42.32,
                    "rob": 110.43
                },
                "compare": {
                    "channel": 81,
                    "lob": 81,
                    "rob": 81
                }
            },
            {
                "cross_section": "1226",
                "base": {
                    "channel": 256.78,
                    "lob": 218.92,
                    "rob": 269.55
                },
                "compare": {
                    "channel": 271,
                    "lob": 271,
                    "rob": 271
                }
            }
        ]
    }
]